import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import { BsXCircle } from "react-icons/bs";
import TextField from '@mui/material/TextField';
import Countdown from 'react-countdown';
import { BUY_TURN, SHOW_MSISDN, SHOW_OTP, SHOW_PACKAGE, SHOW_SUCCESS } from '../../common/constant';
import { customStyles, headerContainerStyle, iconStyle, titleStyle, textStyle } from '../../common/modalStyle'
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { store } from '../..';
import { setShowBuyTurnModal, setShowConfirmModal, setShowResultModal } from '../../actions/modal';
import { success } from '../../common/errorCode';
import MyButton from '../MyButton';
import { useTranslation } from "react-i18next";

const MyConfirmModal = ({ isOpenOtp }) => {
    const { t } = useTranslation();

    let modalReducer = useSelector((state) => state.ModalReducer);
    console.log("modalReducer MyResultModal: " + JSON.stringify(modalReducer));

    const navigate = useNavigate();

    let desField = <div></div>
    let timeField = <div></div>
    let textField = <div></div>

    let color = modalReducer.dataToModal.errorCode == success ? "green" : "red";
    function closeModal() {
        store.dispatch(setShowConfirmModal(false));
    }

    function confirmClick() {
        if (modalReducer.dataToModal.action = BUY_TURN) {
            // open buy turn
            store.dispatch(setShowBuyTurnModal(true));
        }
    }

    return (
        <div>
            <Modal
                isOpen={isOpenOtp}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Confirm Modal"
            >
                <div style={headerContainerStyle}>
                    <div style={iconStyle} onClick={closeModal}>
                        <BsXCircle style={{ height: "2rem", width: "2rem" }} />
                    </div>
                </div>
                {desField}
                <div style={{
                    color: color,
                    textAlign: "center",
                    marginTop: "20px"
                }}>
                    {modalReducer.dataToModal.message}
                </div>
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    {textField}
                </div>
                {timeField}
                <div style={{ marginTop: "20px" }}>
                </div>
                <div className='row' style={{
                    margin: "auto",
                    width: "calc(100% - 20px)"
                }}>
                    <div className='col-6'>
                        <MyButton name={modalReducer.dataToModal.action = BUY_TURN ? "BUY MORE TURN" : "REGISTER"}
                            onClickButton={() => confirmClick()} />
                    </div>
                    <div className='col-6'>
                        <MyButton name={t("close").toUpperCase()} onClickButton={() => closeModal()} background={"gray"} />
                    </div>
                </div>
                <div style={{ marginTop: "20px" }}>
                </div>
            </Modal>
        </div>
    );
}

export default MyConfirmModal;